// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_49-7";
export var adjustableWidthBorderHeld = "_49-8";
export var arrow = "_49-3";
export var arrowButton = "_49-4";
export var headerCell = "_49-0";
export var help = "_49-2";
export var icon = "_49-1";
export var iconWrapper = "_49-6";
export var noBorder = "_49-b";
export var nonAdjustableWidthBorder = "_49-9";
export var nonAdjustableWidthBorderHeld = "_49-a";
export var textButton = "_49-5";